import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import TableViewOutlinedIcon from '@mui/icons-material/TableViewOutlined';
import { Box, Stack, Typography } from '@mui/material';

import { DreExportarRelatorioBtn, DreReportType } from 'pages/financeiro/dre/relatorio/components/atoms/DreExportarRelatorioBtn';
import { FilterValuesProps } from 'hooks/useFilter';

interface DrePainelExportacaoProps {
    reportType: DreReportType;
    disableBtn: boolean;
    filter: FilterValuesProps[];
}

export function DrePainelExportacao({ disableBtn, reportType, filter }: DrePainelExportacaoProps) {
    return (
        <Stack direction="row" sx={{ alignItems: 'center', flexWrap: 'wrap', my: 2, gap: 2 }}>
            <Box sx={{ flex: 1, display: 'inherit', alignItems: 'inherit' }}>
                <TableViewOutlinedIcon color="primary" />

                <Typography sx={{ ml: 2, mr: 1 }}>RELATÓRIOS REFERENTES AO PERÍODO SELECIONADO</Typography>

                <ChevronRightOutlinedIcon color="primary" />
            </Box>
            <DreExportarRelatorioBtn
                disabled={disableBtn}
                reportType={reportType}
                label={'Relatório em .xlsx'}
                sx={{ color: 'green', borderColor: 'green' }}
                filter={filter}
            />
        </Stack>
    );
}
